// 项目属性类型
export enum EProjectAttributeType {
    Type = 10,  // 项目类型
    Level = 30, // 项目级别
    Category = 40,  // 业务分类
    Group = 50  // 项目群
}